import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ClientsExportQuery, ClientsExportQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ClientsExportQuery)
@Wrapper(ClientsExportQueryHandlerBase)
export class ClientsExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
